/**
 * @version 2.0alpha
 * @author Kelnik Studios {http://kelnik.ru}
 * @link https://kelnik.gitbooks.io/kelnik-documentation/content/front-end/components/пока нет documentation
 */

/**
 * DEPENDENCIES
 */

/* eslint-disable */
import FullSlider from 'components/full-slider';
import Mediator from 'common/scripts/mediator';
import Hammer from 'hammerjs';
import sliderTemplate from './slider.twig';
import Utils from 'common/scripts/utils';
import SliderArrows from 'components/slider-arrows';
import LazyLoad from "vanilla-lazyload";
import TouchZoom from "components/touch-zoom";

const mediator = new Mediator();

class Slider {
    /**
     * Инициализация параметров
     */
    init(options) {
        this.gallery = options.target;
        this.transitionTime = options.transitionTime || 300;
        this.infinite = options.infinite || false;
        this.autoplay = options.autoplay || false;
        this.autoplaySpeed = options.autoplaySpeed || 3000;
        this.dots = options.dots || false;
        this.full = this.gallery ? Boolean(this.gallery.dataset.full) : false;
        this.childrens = Array.from(this.gallery.children);
        this.itemsCount = this.childrens.length;
        this.activeSlide = 1;
        this.width = 0;
        this.position = 0;
        this.flexHeight = false;
        this.vertical = options.vertical || false;
        this.sliderArrow = Boolean(options.sliderArrow);
        this.separateArrow = Boolean(options.separateArrow);
        this.zoom = options.zoom || false;
        this.slides = [];
        this.touchZooms = [];

        // Utils.clearHtml(this.gallery); //почему то в IE очищает - this.childrens

        this.createGallery();
    }

    /**
     * Главный метод. Создает весь слайдер.
     */
    createGallery() {
        Utils.insetContent(this.gallery, sliderTemplate({
            sliderArrow: this.sliderArrow,
            separateArrow: this.separateArrow,
            full         : this.full
        }));

        if (!this.gallery) {
            console.error('Такого контейнера для слайдера не существует!');

            return false;
        }

        this.getElements();
        if (this.dots) {
            this.createDots();
        }
        this.appendChilds();
        this.bindEvents();
        this.setHeight();
        this.dotActivate();
        this.ready();
        this.autoplayStart();
        this.createCounter();
        this.initArrows();
        this.initFull();

        if (this.itemsCount === 1) {
            const counter = this.gallery.querySelector('.b-slider__counter');
            const arrows = this.gallery.querySelector('.b-slider__arrows');

            counter.style.display = 'none';
            arrows.style.display = 'none';
        }
    }

    /**
     * Получаем элементы слайдера.
     */
    getElements() {
        this.dotsWrapper = this.gallery.querySelector('.b-slider__dots');
        this.wrapper = this.gallery.querySelector('.b-slider__wrapper');
        this.arrowLeft = this.gallery.querySelector('.slider__arrow-left');
        this.arrowRight = this.gallery.querySelector('.slider__arrow-right');
        this.countActive = this.gallery.querySelector('.b-slider__counter-active');
        this.countAll = this.gallery.querySelector('.b-slider__counter-all');
        this.fullEl = this.gallery.querySelector('.b-slider__full');
    }

    createCounter() {
        this.countActive.innerHTML = this.activeSlide;
        this.countAll.innerHTML = this.itemsCount;
    }

    initArrows() {
        this.arrowsEl = this.gallery.querySelector('.j-slider-arrows');

        if (!this.arrowsEl) {
            return;
        }

        this.arrows = new SliderArrows({
            container: this.arrowsEl,
            timeout  : () => {
                if (!this.isSlideRight()) {
                    this.transitionControl();
                    this.slideTo(0);
                    this.activeSlide = 1;
                    this.dotActivate();
                    this.refresh();
                }
            }
        });
        this.arrows.init();
    }

    initFull() {
        if (!this.full || !this.fullEl) {
            return;
        }

        this.fullSlider = new FullSlider();

        this.fullEl.addEventListener('click', () => {
            const pictures = Array.from(this.wrapper.querySelectorAll('picture'));
            const images = pictures && pictures.length ? pictures : Array.from(this.wrapper.querySelectorAll('img'));

            if (images && images.length) {
                this.fullSlider.toOpen({elements: images});
            }
        });
    }

    /**
     * возвращает число в формате 00 (дизайн)
     * @param {Number} number - число
     * @returns {string}
     */
    numberFormat(number) {
        return ('0' + number).slice(-2);
    }

    /**
     * Создаёт точки в html.
     */
    createDots() {
        for (let i = 0; i < this.itemsCount; i++) {
            this.dotsWrapper.appendChild(this.createDot());
        }
    }

    /**
     * Создаёт точку.
     * @return {HTMLButtonElement}
     */
    createDot() {
        const dot = document.createElement('button');

        dot.classList.add('b-slider__dot');

        return dot;
    }


    /**
     * Навешивает события на контролы
     */
    bindEvents() {
        const touchEvent = new Hammer(this.gallery);

        touchEvent.on('swiperight', () => {
            if (this.arrows) {
                this.arrows.stopTimer();
            }

            this.isSlideLeft();
        });
        touchEvent.on('swipeleft', () => {
            if (this.arrows) {
                this.arrows.stopTimer();
            }

            this.isSlideRight();
        });

        if (this.zoom) {
            this.slides.forEach((slide) => {
                this.initTouchZoom(slide.firstElementChild);
            });
        }

        this.arrowLeft.classList.add('is-last');

        this.arrowLeft.addEventListener('click', this.isSlideLeft.bind(this), false);
        this.arrowRight.addEventListener('click', this.isSlideRight.bind(this), false);

        this.dotsWrapper.addEventListener('click', (event) => {
            const index = Utils.getElementIndex(event.target) + 1;

            this.activeSlide = index;
            this.dotActivate();
            this.slideTo(this.goTo(index));
        });

        window.addEventListener('resize', () => {
            this.refresh();
        });
    }

    initTouchZoom(element) {
        const touchZoom = new TouchZoom({
            target: element
        });
        this.touchZooms.push(touchZoom);
    }

    refresh() {
        const currentSlide = this.gallery.querySelectorAll('.b-slider__item')[this.activeSlide - 1];

        if (!currentSlide) {
            return;
        }
        this.width = this.vertical ?
          currentSlide.offsetHeight :
          currentSlide.offsetWidth;
        this.position = -(this.width * (this.activeSlide - 1));
        this.slideTo(this.position);
        this.setHeight();
        if (this.zoom) {
            this.touchZooms.forEach((touchZoom) => {
                if (touchZoom.wrapper === currentSlide) {
                    touchZoom.updateScaleValue();
                }
            });
        }
    }

    /**
     * Добавляет слайды.
     */
    appendChilds() {
        for (let i = 0; i < this.childrens.length; i++) {
            const item = document.createElement('div');

            item.classList.add('b-slider__item');
            item.appendChild(this.childrens[i]);

            this.wrapper.appendChild(item);
            this.width = this.wrapper.offsetWidth - this.getScrollbarWidth();
            this.slides.push(item);
        }
    }

    getScrollbarWidth() {
        const outer = document.createElement('div');

        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        document.body.appendChild(outer);

        const widthNoScroll = outer.offsetWidth;

        outer.style.overflow = 'scroll';

        const inner = document.createElement('div');

        inner.style.width = '100%';
        outer.appendChild(inner);

        const widthWithScroll = inner.offsetWidth;

        outer.parentNode.removeChild(outer);

        return widthNoScroll - widthWithScroll;
    }

    /**
     * Определяет максимальную высоту слайдов, и устанавливает ее обертке ().
     */
    setHeight() {
        const currentSlide = this.wrapper.querySelector(`.b-slider__item:nth-child(${this.activeSlide})`);
        if (!currentSlide) {
            return;
        }

        const lazyLoadElement = currentSlide.querySelector('.j-lazy');

        if (lazyLoadElement && !(lazyLoadElement.classList.contains('loaded') || lazyLoadElement.classList.contains('loading'))) {
            this._lazyLoadImg(lazyLoadElement);
        }

        const currentImg = currentSlide.querySelector('img');

        if (currentImg) {
            let slideHeight = currentSlide.offsetHeight;
            currentImg.onload = () => {
                slideHeight = currentSlide.offsetHeight;
                // this.wrapper.style.setProperty('height', `${slideHeight}px`, '');
            };
        }
    }

    _lazyLoadImg(element) {
        LazyLoad.load(element, {
            // eslint-disable-next-line camelcase
            callback_loading : (el) => {
                el.parentElement.classList.add('loading');
            },
            // eslint-disable-next-line camelcase
            callback_loaded: (el) => {
                el.parentElement.classList.add('loaded');
            }
        });
    }

    /**
     * Меняет активное значение у точки.
     */
    dotActivate() {
        this.allDots = Array.from(this.gallery.querySelectorAll('.b-slider__dot'));
        const activeDotClass = 'b-slider__dot_is_active';

        this.allDots.forEach((element, index) => {
            if (this.activeSlide - 1 === index) {
                element.classList.add(activeDotClass);
                this.transitionControl();
            } else {
                element.classList.remove(activeDotClass);
            }
        });
    }

    /**
     * Показывает слайдер когда все методы выполнятся.
     */
    ready() {
        this.gallery.classList.add('b-slider_is_ready');
        mediator.publish('sliderReady');
    }

    /**
     * Перелистывает к переданной позиции.
     * @param {Number} toPosition - позиция слайдера по X оси.
     */
    slideTo(toPosition) {
        if (this.vertical) {
            this.wrapper.style.transform = `translateY(${toPosition}px)`;
        } else {
            this.wrapper.style.transform = `translateX(${toPosition}px)`;
        }
    }

    /**
     * Листает слайдер вправо.
     */
    slideLeft() {
        this.transitionControl();
        this.slideTo(this.position);
        this.activeSlide -= 1;
        this.dotActivate();
        this.refresh();
    }

    /**
     * Листает слайдер влево.
     */
    slideRight() {
        this.transitionControl();
        this.slideTo(this.position);
        this.activeSlide += 1;
        this.dotActivate();
        this.refresh();
    }

    /**
     * Проверяет можно ли листать влево (если не нужен инфинити скролл, то в if просто вернуть false).
     */
    isSlideLeft() {
        this.arrowRight.classList.remove('is-last');

        if (this.position >= 0) {
            if (!this.infinite) {
                return false;
            }
            this.position = -((this.itemsCount - 1) * this.width);
            this.activeSlide = this.itemsCount + 1;
        } else {
            this.position += this.width;
        }
        if (this.gallery.classList.contains('j-benefits-slider')) {
            mediator.publish('benefitGoesLeft', this.activeSlide);
        }

        if (this.activeSlide === 2) {
            this.arrowLeft.classList.add('is-last');
        }

        this.countActive.innerHTML = this.activeSlide - 1;
        this.slideLeft();
    }

    /**
     * Проверяет можно ли листать вправо (если не нужен инфинити скролл, то в if просто вернуть false).
     */
    isSlideRight() {
        let parentWidth = this.gallery.offsetWidth;
        let slideWidth = this.gallery.querySelector('.b-slider__item').offsetWidth;
        let slideStop = Math.round(parentWidth / slideWidth);
        if (this.vertical) {
            const parentHeight = this.wrapper.offsetHeight;
            const slides = Array.from(this.gallery.querySelectorAll('.b-slider__item'));
            slideStop = 0;
            slides.reduce((accumulator, slide, index) => {
                if (parentHeight > accumulator) {
                    slideStop = index + 1;
                    return accumulator + slide.offsetHeight;
                }
            }, 0);
        }

        this.arrowLeft.classList.remove('is-last');

        if (this.position <= -(this.width * (this.itemsCount - slideStop))) {
            if (!this.infinite) {
                return false;
            }
            this.position = 0;
            this.activeSlide = 0;
        } else {
            this.position -= this.width;
        }
        if (this.gallery.classList.contains('j-benefits-slider')) {
            mediator.publish('benefitGoesRight', {position: this.position, slide: this.activeSlide});
        }

        if (this.activeSlide === (this.itemsCount - 1) || (this.vertical && this.activeSlide === (this.itemsCount - slideStop))) {
            this.arrowRight.classList.add('is-last');
        }

        this.countActive.innerHTML = this.activeSlide + 1;
        this.slideRight();
        return true;
    }

    /**
     * Определяет новую позицию слайда в зависимости на какую точку нажали.
     * @param value {number} - Порядковый номер слайда.
     * @return {number} - Новая позиция.
     */
    goTo(value) {
        const newPosition = -(this.width * (value - 1));

        this.position = newPosition;

        return newPosition;
    }

    /**
     * Добавляет transition только на время слайда (чтобы небыло анимации при ресайзе)
     */
    transitionControl() {
        this.wrapper.style.transitionDuration = `${100 / this.transitionTime}s`;

        setTimeout(() => {
            this.wrapper.style.removeProperty('transition-duration');
        }, this.transitionTime);
    }

    /**
     * Метод автопролистывания слайдов.
     * @return {boolean} - если автоплэй не задан либо false, то сетинтервал не работает
     */
    autoplayStart() {
        if (!this.autoplay) {
            return false;
        }

        setInterval(() => {
            this.isSlideRight();
        }, this.autoplaySpeed);
    }
}

export default Slider;
/* eslint-enable */
